var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"component-image-invisible-on-error",class:{'component-image-invisible-on-error_invisible': _vm.isHidden},attrs:{"src":_vm.src,"alt":_vm.alt || ''},on:{"error":_vm.hide}})}
var staticRenderFns = []

export { render, staticRenderFns }